<template>
  <div class="tw-mt-10 lg:tw-mr-96">
    <div class="tw-mb-10 tw-pr-8">
      <div class="tw-pt-4 tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
        <input 
          v-model="state.gift_card.number"
          type="text" 
          name="number" 
          placeholder=" "
          class="tw-block tw-text-2xl tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0 tw-px-0" />
        <label for="number" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Gift Card Number</label>
      </div>
    </div>

    <div class="tw-mb-10 tw-pr-8">
      <div class="tw-pt-4 tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
        <input 
          v-model="state.gift_card.pin"
          type="text" 
          name="pin"
          placeholder=" "
          class="tw-block tw-text-2xl tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0 tw-px-0" />
        <label for="number" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Gift Card PIN</label>
      </div>
    </div>

    <div class="tw-mb-12" v-if="canSaveCard">
      <TwCheckbox
        id="gc_type_new"
        key="gc_type_new"
        label="Save For Future Use"
        value="state.gift_card.saveonfile"
        class="tw-mb-4"
        :checked="state.gift_card.saveonfile"
        @on-change="state.gift_card.saveonfile = !state.gift_card.saveonfile"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref, watch
  } from 'vue';
  import type {PropType} from 'vue';
  import { DateTime } from "luxon";

  import type BillingAccount from '../../classes/BillingAccount';
  import type BasketBillingMethod from '../../classes/BasketBillingMethod';
  import GiftCard from '../../classes/GiftCard';

  import TwCheckbox from '../../components/TwCheckbox.vue';
  import TwButton from '../../components/TwButton.vue';
  import BillingAccountCard from './_BillingAccountCard.vue';

  const props = defineProps({
    billingAccounts: {
      type: (Object as PropType<BillingAccount[]>),
      default: [],
    },
    newGC: {
      type: (Object as PropType<GiftCard> | null),
      required: false,
      default: null,
    },
    canSaveCard: {
      type: Boolean,
      default: false
    }
  });

  const state = reactive({
   gift_card: new GiftCard('', '', false),
   nextTenYears: [] as number[],
  })

  const emit = defineEmits(['setGiftCard'])

  onMounted(() => {
    const current_year = parseFloat(DateTime.now().toFormat('yy'));
    state.nextTenYears = [];
    for (var i = current_year; i <=( current_year + 10); i++) {
      state.nextTenYears.push(i);
    }

  })

  watch(() => state.gift_card, (newGC, oldGC) =>  {
      applyCard();
    },
    { deep: true }
  )

  watch(() => props.newGC, (newGC, oldGC) => { 
  })

  const applyCard = (() => {
    emit('setGiftCard', state.gift_card)
  })

</script>